/* eslint-disable react/display-name */
import React, { forwardRef } from "react";
import { Link } from "../../utils/customLink";

export const VIStickyBar = forwardRef(({ applyLink, enquireNowLink }, ref) => {
  return (
    <div
      className="fixed hidden md:flex bg-white w-full md:z-20 border-0.5 border-gray-testimonial gvi-box-shadow transition-all duration-50
      dark:gvi-blur-bg"
      ref={ref}
    >
      <div className="gvi-container flex justify-between items-center mx-auto py-7">
        <h2 className="font-normal font-alice dark:font-body">
          Virtual internship programs
        </h2>

        <div className="flex flex-col md:flex-row gap-3">
          <Link
            className="submit-button group flex justify-center items-center px-20 py-2"
            to={applyLink}
          >
            <p className="pr-2 font-bold">Apply</p>
          </Link>
          <Link
            className="callback-button group flex justify-center items-center px-20 py-2 bg-white hover:bg-black-lighter hover:text-white dark:bg-transparent dark:hover:bg-white dark:hover:text-gray-darker"
            to={enquireNowLink}
          >
            <p className="pr-2">Enquire</p>
          </Link>
        </div>
      </div>
    </div>
  );
});
